import { gql } from '@apollo/client';

export const GET_SOCIAL_MEDIA_INTEGRATION_SETTINGS = gql`
  query GetSocialMediaIntegrationSettings {
    getSocialMediaIntegrationSettings {
      id
      allowedUsers {
        id
        firstName
        lastName
        storeDetails {
          storeName
        }
      }
      ... on SocialMediaIntegrationNewFlowSettings {
        isEnabled
      }
    }
  }
`;

export const GET_CB_SOCIAL_MEDIA_FLOW_SETTINGS = gql`
  query GetCbSocialMediaFlowSettings {
    getCbSocialMediaFlowSettings {
      id
      allowedUsers {
        id
        firstName
        lastName
        storeDetails {
          storeName
        }
      }
      isEnabled
    }
  }
`;
